
define('text!modules/strategy/creatives/templates/grid_footer.html',[],function () { return '{{#browse_path_end}}\n<div class="browse-path" data-bind="browse_path">{{{browse_path}}}<span class="strong">{{{browse_path_end}}}</span></div>\n{{/browse_path_end}}';});

